import React from 'react';

import { DecisionMakerIcon } from '@change/ds-icons';

import { Badge, Card, Text } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../shared/types';
import { Location } from '../shared/Location';

import { Member } from './Member';
import { ViewMore } from './ViewMore';

export const LegislativeBodyCard: React.FC<{
	legislativeBody: LegislativeBody;
}> = ({ legislativeBody }) => {
	const { title, location, displayedDMs, viewMoreText, responsesText, allDMs } = legislativeBody;

	return (
		<Card className="bg-fill-inverse-strong mb-6 p-6 shadow-md">
			<div className="mb-6 flex">
				<div>
					<div className="bg-fill-accent-primary-weaker mr-4 flex size-16 items-center justify-center rounded-full lg:size-20">
						<DecisionMakerIcon size="large" className="text-typography-information" />
					</div>
				</div>
				<div className="w-full">
					<div className="lg:flex lg:items-start">
						<div className="w-fit">
							<Text variant="heading" className="mb-[6px] mr-2 block text-lg font-bold lg:mb-0 lg:text-2xl">
								{title}
							</Text>

							<Text className="mb-4 block lg:mb-0 lg:text-lg"> {allDMs.length} Members</Text>
						</div>

						<div className="min-w-32 lg:ml-auto lg:mt-2">
							{responsesText && (
								<Badge
									label={responsesText}
									variant="neutral"
									className="bg-fill-success-weaker border-stroke-success-weak text-typography-success mb-2 w-fit border-[1px] font-normal lg:ml-auto"
								/>
							)}
						</div>
					</div>

					{location && <Location location={location} />}
				</div>
			</div>

			<div className="mx-4 lg:mx-12">
				{displayedDMs.map((dm) => (
					<div className="mb-4 ml-5 lg:ml-12" key={dm.id}>
						<Member {...dm} />
					</div>
				))}
				{viewMoreText && <ViewMore legislativeBody={legislativeBody} />}
			</div>
		</Card>
	);
};
